import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Box,
  Container,
  Grid,
  Heading,
  Text,
} from '@joinrepublic/dls-ui-kit';

import { colors, containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { LEARN_SECTIONS, MAIN_SECTIONS } from './data';

export const Regulations = () => {
  return (
    <Box
      as="section"
      id="regulations"
      bg={colors.warmGray}
      pt={{ base: '14', sm: '24' }}
      pb={{ base: '16', sm: '18' }}
      sx={{
        textWrap: 'pretty',
      }}
    >
      <Container maxW={containerSize}>
        <MotionBox>
          <Heading
            as="h2"
            mt="0"
            mb={{ base: '9', sm: '18' }}
            size="title-md"
            color={colors.darkNavyTypography}
          >
            Regulation-first
          </Heading>

          <Grid
            gap={{ base: '14', sm: '8' }}
            templateColumns={{
              base: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            }}
            pr={{ base: '0', md: '4%' }}
          >
            {MAIN_SECTIONS.map(({ icon, title, body }, index) => (
              <Box key={index} pr={{ base: '0', sm: '8' }}>
                <Box as="figure" mb="6" color="black" aria-hidden="true">
                  {icon}
                </Box>
                <Text size="body-lg">{title}</Text>
                <Text mt="2.5" size="body-md" variant="text-secondary">
                  {body}
                </Text>
              </Box>
            ))}
          </Grid>
        </MotionBox>

        <MotionBox delay={0.2} effect="fadeIn">
          <Accordion
            variant="group"
            allowToggle
            mt="14"
            borderY="1px solid"
            borderColor="blackAlpha.300"
          >
            <AccordionItem p="0" _last={{ border: 'none' }}>
              <AccordionHeader
                px="0"
                py={{ base: '6', sm: '4' }}
                _hover={{ color: 'currentColor' }}
              >
                <Text size="body-lg">Learn more</Text>
              </AccordionHeader>
              <AccordionPanel px="0" pb="4">
                <Box overflow="hidden">
                  <Grid
                    columnGap={8}
                    rowGap={6}
                    templateColumns={{
                      base: '1fr',
                      sm: 'repeat(2, 1fr)',
                      md: 'repeat(3, 1fr)',
                    }}
                    mt="-2"
                    pr={{ base: '0', md: '4%' }}
                  >
                    {LEARN_SECTIONS.map(({ title, body, note }, index) => (
                      <Box
                        key={index}
                        borderTop="1px solid"
                        borderColor="blackAlpha.300"
                        pt={{ base: '4', sm: '4' }}
                        pr={{ base: '0', sm: '8' }}
                        minH={{ base: 'auto', sm: '100px' }}
                      >
                        <Text size="body-sm" textStyle={{ sm: 'body-sm-md' }}>
                          {title}
                        </Text>
                        <Text mt="2.5" size="body-sm" variant="text-secondary">
                          {body}
                        </Text>
                        {note && (
                          <Text mt="3" size="body-sm" color="grey.400">
                            <InfoOutlineIcon
                              mt="-0.5"
                              mr="1"
                              color="grey.300"
                              boxSize="4"
                            />
                            {note}
                          </Text>
                        )}
                      </Box>
                    ))}
                  </Grid>
                </Box>

                <Text mt="5" size="body-sm" color="grey.400">
                  *Licensed entities are owned and operated by The INX Digital
                  Company Inc. pending closing of acquisition by Republic.
                </Text>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </MotionBox>
      </Container>
    </Box>
  );
};
